import clsx from 'clsx';
import AgyleDialog from './agyleDialog';
import React from 'react';
import makeStyles from '@mui/styles/makeStyles';
import {useSelector} from 'react-redux';
import {ctxSplitScreen} from '../../store/reducers/patientContext';

const useStyles = makeStyles((theme) => ({
        backgroundOverride: {
            backgroundColor: `${theme.palette.inPatient.formBackground} !important`,
        },
        actionNoDivider: {
            borderBottom: 'none',
        },
        maxHeight: {
            maxHeight: 'calc(100vh - 400px)',
        },
        title: {
            fontSize: 16,
        },
    }),
);

const MiniFormDialog = (props) => {
    const classes = useStyles();
    const splitScreen = useSelector(ctxSplitScreen);

    return (
        <AgyleDialog
            fullWidth
            closeButtonOnHeader
            titleStyle={clsx(classes.backgroundOverride, classes.title)}
            actionStyle={classes.backgroundOverride}
            contentStyle={clsx(classes.backgroundOverride, classes.actionNoDivider, classes.maxHeight)}
            width={props.formOptions?.dialogWidth || 'md'}
            disablePortal={splitScreen.enabled}
            {...props}
        >
            <>
                {props.children}
            </>
        </AgyleDialog>
    );
};

export default MiniFormDialog;